import { Tag as BPTag } from "@blueprintjs/core";
import React from "react";

import { Tag as TTag } from "../../redux/slices";

interface TagProps {
  tag: TTag;
  className?: string;
}

export const Tag = ({ tag, className = "" }: TagProps) => {
  return (
    <BPTag className={className} style={{ color: tag.textColor, backgroundColor: tag.color }}>
      {tag.name}
    </BPTag>
  );
};
